import { style } from '@do/walrus';
import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewSuccessBanner = styled.div`
  background: ${newBrandDesignVars.green_lightest};
  padding: ${style.vars.whitespace.regular};
  border-radius: ${newBrandDesignVars.border_radius_xlarge};
  border: ${style.vars.borderWidth.thin} solid
    ${newBrandDesignVars.green_darkest};
  margin-bottom: ${style.vars.space['4']};
  color: ${newBrandDesignVars.dark};

  & img {
    margin-right: ${style.vars.whitespace.small};
    margin-top: -2px;
  }
`;

export default NewSuccessBanner;
